
<template>
  <footer class="footer">
    <section class="container" ><div class="footer-cont flex flex-between" >
      <div class="footer-menu" >
        <dl ><dt >论文服务</dt> 
          <dd ><a href="/service?page=0"  data-ga="foot_link_论文服务">SCI论文英文润色</a></dd>
          <dd ><a href="/service?page=1"  data-ga="foot_link_论文服务">专业学术翻译</a></dd>
          <dd ><a href="/service?page=2"  data-ga="foot_link_论文服务">论文语言改写</a></dd>
          <dd ><a href="/service?page=3"  data-ga="foot_link_论文服务">SCI论文发表支持</a></dd>
          <dd ><a href="/service?page=4"  data-ga="foot_link_论文服务">论文图表</a></dd>
          <dd ><a href="/service?page=5"  data-ga="foot_link_论文服务">图文摘要</a></dd>
          <dd ><a href="/service?page=6"  data-ga="foot_link_论文服务">统计分析</a></dd>
        </dl>
        <dl ><dt >技术服务</dt> 
          <dd ><a href="/tech?page=0"  data-ga="foot_link_技术服务">形态病理学</a></dd>
          <dd ><a href="/tech?page=1"  data-ga="foot_link_技术服务">分子生物学</a></dd>
          <dd ><a href="/tech?page=2"  data-ga="foot_link_技术服务">细胞学</a></dd>
          <dd ><a href="/tech?page=3"  data-ga="foot_link_技术服务">斑马鱼实验</a></dd>
          <dd ><a href="/tech?page=4"  data-ga="foot_link_技术服务">病毒包装</a></dd>
          <dd ><a href="/tech?page=5" data-ga="foot_link_技术服务">拍片及分析</a></dd>
          <dd ><a href="/tech?page=6" data-ga="foot_link_技术服务">动物造模</a></dd>
        </dl>
        <dl ><dt >其它服务</dt> 
          <dd ><a href="/other?page=0"  data-ga="foot_link_其它服务">基金标书服务</a></dd>
          <dd ><a href="/other?page=1"  data-ga="foot_link_其它服务">学术海报</a></dd>
       <!--    <dd ><a href="/guide?page=0"   data-ga="foot_link_其它服务">影响因子查询</a></dd> -->
          <dd ><a href="/guide?page=0"  data-ga="foot_link_其它服务">帮助中心</a></dd>
        </dl>
        <dl ><dt >关于我们</dt> 
        <dd ><a href="/contact?page=0"  data-ga="foot_link_关于我们">了解格兰博</a></dd>
        <dd ><a href="/contact?page=1"  data-ga="foot_link_关于我们">联系我们</a></dd>
        </dl>
        </div> 
        <div class="contact flex flex-column" >
          <div class="service flex-s" ><p ><a href="tel:193-5723-9768" ><i class="el-icon-phone-outline icon-phone icon" ></i>193-5723-9768</a></p> 
          <p ><a href="mailto:grantbio@163.com" ><i class="el-icon-message icon-email icon" ></i>grantbio@163.com</a></p>
          <span style="margin-right: 0px;"><img  src="../assets/images/wx.jpg">关注微信 </span></div> 
        </div>
        </div>
          <div class="copy" >
            © 格兰博生物 版权所有
            <span ><a target="_blank" href="https://beian.miit.gov.cn/" >工信部备案号：浙ICP备2021029819号</a> </span>
          </div>
        </section>
      </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer{
    font: 14px/1.625 PingFang SC,Microsoft YaHei,Helvetica Neue,Open Sans,Arial,Hiragino Sans GB,微软雅黑,STHeiti,SimSun,sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    z-index: 8;
    background-color: #111b31;
    color: #fff;
    padding-top: 20px;
    .footer-cont{
      padding: 60px 0;
      .footer-menu{
        dl{
          font-size: 18px;
          float: left;
          width: 190px;
          dt{
            margin-bottom: 16px;
            font-weight: 600;
          }
          dd{
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 8px;
            margin-inline-start: 5px;
            a{
              color: hsla(0,0%,100%,.7);
              font-weight: 400;
              transition: all .12s linear;
              text-decoration:none;
            }
          }
        }
      }
    }
}
.container{
  width: 1360px;
  margin-left: auto;
  margin-right: auto;
}
.contact{
  .service{
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    .icon{
      font-size: 16px;
      line-height: 24px;
      display: inline-block;
      vertical-align: top;
      margin-right: 8px;
      width: 20px;
      text-align: center;
    }
    a{
      text-decoration:none
    }
    span{
      text-align: center;
      line-height: 30px;
      margin-top: 20px;
      width: 140px;
      display: block;
      float: left;
      color: #888;
      font-size: 14px;
      img{
        width: 140px;
      }
    }
  }
}
.flex{
  display: flex;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  .flex-s{
    flex:1;
    min-width: 0;
  }
}
.flex-column{
  flex-flow: column;
}
.flex-between {
    justify-content: space-between;
}
.copy{
  border-top: 1px solid hsla(0,0%,100%,.2);
  line-height: 20px;
  padding: 16px 0;
  font-size: 12px;
  color: hsla(0,0%,100%,.7);
  a{
    color: hsla(0,0%,100%,.7);
    margin-left: 20px;
    text-decoration:none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue